import { render, staticRenderFns } from "./personHome.vue?vue&type=template&id=98c90076&"
import script from "./personHome.vue?vue&type=script&lang=js&"
export * from "./personHome.vue?vue&type=script&lang=js&"
import style0 from "./personHome.vue?vue&type=style&index=0&id=98c90076&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98c90076')) {
      api.createRecord('98c90076', component.options)
    } else {
      api.reload('98c90076', component.options)
    }
    module.hot.accept("./personHome.vue?vue&type=template&id=98c90076&", function () {
      api.rerender('98c90076', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/personHome/personHome.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/personHome/personHome.vue
// module id = 4XpD
// module chunks = 0